import React from "react";
import Image from "next/image";
import clsx from "clsx";

export type ProductRevenueProps = {
  title: string;
  highlight: string;
  titleHeight?: number;
  revenueStreams: {
    title: string;
    description: string;
    image: string;
  }[];
};

export default function ProductRevenueSection({
  title,
  highlight,
  revenueStreams,
  titleHeight,
}: ProductRevenueProps) {
  const [before, after] = title.split(highlight);

  return (
    <section className="flex flex-col gap-10">
      <div className="flex justify-center flex-col md:flex-row gap-4">
        <div className="flex gap-2 flex-col items-center justify-center">
          <span className="md:text-[45px] text-2xl text-secondary-900 font-bold md:text-center leading-tight">
            {before}{" "}
            <span className="bg-gradient-to-r from-[#4337cc] to-primary-900 bg-clip-text text-transparent">
              {highlight}
            </span>{" "}
            {after}
          </span>
        </div>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-3 gap-8 text-secondary-900 items-stretch">
        {revenueStreams.map((revenue) => (
          <div
            key={revenue.title}
            className="flex flex-col gap-8 p-8 border rounded-xl hover:text-white hover:bg-gradient-to-r hover:from-[#4337cc] hover:to-primary-900"
          >
            <Image
              priority
              src={revenue.image}
              alt="Products Hero Background Image"
              height={50}
              width={120}
              className="object-contain mx-auto mb-4 h-[100px]"
            />
            <div className="flex flex-col flex-grow justify-start gap-2 text-center">
              <span
                className={clsx(
                  "text-xl md:text-[27px] font-bold ",
                  titleHeight && `md:min-h-[${titleHeight}px]`
                )}
              >
                {revenue.title}
              </span>
              <span className="text-base md:text-lg min-h-[48px]">
                {revenue.description}
              </span>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
}
